let _appType = '';
const FJTextToVideoStore = {
    setAppType(appType) {
        _appType = appType;
    },
    getAppType() {
        return _appType;
    },
};
export default FJTextToVideoStore;
